import React, { useState } from 'react';
import { SAFE_DEAL_CLICK_SOURCE } from '@olxeu-a2b/delivery-utils/src/constants';
import InfoModal from '@olxeu-a2b/ui/src/commons/components/InfoModal';
import InfoButton from '@olxeu-a2b/ui/src/commons/components/InfoButton';
import { useI18n } from '@olxeu-a2b/ui/src/i18n';
import trackingKeys from '@olxeu-a2b/ui/src/commons/constants/trackingKeys';
import { EXTERNAL_LINKS } from '../../../ad/components/constants';
import { USER_TYPE } from '../../constants';

interface SafeDealExtendedCoverageInfoModalProps {
  desktop: boolean;
  userType: USER_TYPE;
  trackInfoClick: () => void;
}

const SafeDealExtendedCoverageInfoModal: React.FC<SafeDealExtendedCoverageInfoModalProps> = ({
  desktop,
  userType,
  trackInfoClick,
}) => {
  const i18n = useI18n();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const onOpenModalBtnClickHandler = () => {
    trackInfoClick();
    setIsModalVisible(true);
  };

  const handleModalToggle = (toggle: boolean) => setIsModalVisible(toggle);

  const versionSuffix = userType === USER_TYPE.SELLER ? '_seller' : '_buyer';

  return (
    <>
      <InfoButton
        infoTrigger={onOpenModalBtnClickHandler}
        btnTextKey="dlv_safedeal_extended_coverage_info_button"
      />
      {isModalVisible && (
        <InfoModal
          handleModalToggle={handleModalToggle}
          isDesktop={desktop}
          headerTextKey="dlv_safedeal_extended_coverage_modal_title"
          descriptionTextKeys={{
            main: `dlv_orders_extended_coverage_description_1${versionSuffix}`,
            important: `dlv_orders_extended_coverage_description_2${versionSuffix}`,
            main2: `dlv_orders_extended_coverage_description_3${versionSuffix}`,
            important2:
              userType === USER_TYPE.BUYER
                ? `dlv_orders_extended_coverage_description_4_buyer`
                : null,
          }}
          contentTextKeys={[
            {
              tickDescription: `dlv_orders_extended_coverage_list_item_tick_1${versionSuffix}`,
              tickImportant:
                userType === USER_TYPE.SELLER
                  ? `dlv_orders_extended_coverage_list_item_tick_1_important_seller`
                  : null,
            },
            {
              tickDescription: `dlv_orders_extended_coverage_list_item_tick_2${versionSuffix}`,
              tickImportant:
                userType === USER_TYPE.SELLER
                  ? `dlv_orders_extended_coverage_list_item_tick_2_important_seller`
                  : null,
              tickPoint:
                userType === USER_TYPE.BUYER
                  ? [
                    <span>
                      <strong>{i18n`dlv_orders_extended_coverage_list_item_dot_1_important_buyer`}</strong>{' '}
                      {i18n`dlv_orders_extended_coverage_list_item_dot_1_buyer`}
                    </span>,
                    <span>
                      <strong>{i18n`dlv_orders_extended_coverage_list_item_dot_2_important_buyer`}</strong>{' '}
                      {i18n`dlv_orders_extended_coverage_list_item_dot_2_buyer`}
                    </span>,
                  ]
                  : null,
            },
          ]}
          lowerDescriptionTextKeys={
            userType === USER_TYPE.SELLER
              ? {
                main: 'dlv_orders_extended_coverage_lower_description_seller',
                important: 'dlv_orders_extended_coverage_lower_description_important_seller',
                dot1: 'dlv_orders_extended_coverage_lower_description_dot_1_seller',
                dot2: 'dlv_orders_extended_coverage_lower_description_dot_2_seller',
              }
              : null
          }
          readMore={i18n`dlv_orders_extended_coverage_read_more`}
          readMoreLink={EXTERNAL_LINKS.SAFE_DEAL_EXTENDED_TERMS}
          source={SAFE_DEAL_CLICK_SOURCE.INFO_ICON_BUTTON}
          closeModalTrackingKey={trackingKeys.events.safeDeal.closeModalSafeDealBtn}
        />
      )}
    </>
  );
};

export default SafeDealExtendedCoverageInfoModal;
